export const parseBoolean = (
  val: boolean | string | number | null | undefined,
  fallbackValue?: boolean
): boolean => {
  if (val !== undefined && val !== null) {
    if (['true', 'TRUE', '1', 1, true].includes(val)) {
      return true
    }
    if (['false', 'FALSE', '0', 0, false].includes(val)) {
      return false
    }
  }
  if (fallbackValue === undefined) {
    throw new Error('Value cannot be parsed as boolean')
  }
  return fallbackValue
}
